// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b4025aa7","239":"7f98e3ff","453":"8044acca","455":"24d29f3f","726":"816655bb"}[chunkId] + ".chunk.js";
};